document.addEventListener('DOMContentLoaded', () => {
  const KLAVIYO_SITE_ID = 'VjjJCi';
  const KLAVIYO_LIST_ID = 'Yp2X2R';

  const form = document.querySelector('.ftb-restock-modal__form');
  const successMessage = document.querySelector('.ftb-restock-modal__success');

  if (!form) return;

  const submitButton = form.querySelector('.ftb-restock-modal__submit');
  const emailInput = form.querySelector('#ftb-restock-email');
  const phoneInput = form.querySelector('#ftb-restock-phone');
  const smsConsentInput = form.querySelector('[name="sms_consent"]');

  const productInput = form.querySelector('#ftb-restock-product');
  const variantInput = form.querySelector('#ftb-restock-variant');
  const variantIdInput = form.querySelector('#ftb-restock-variant-id');

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const email = emailInput?.value.trim();
    const phone = phoneInput?.value.trim();
    const smsConsent = Boolean(smsConsentInput?.checked);

    if (!email) {
      emailInput?.focus();
      return;
    }

    if (smsConsent && !phone) {
      phoneInput?.focus();
      return;
    }

    const originalButtonText = submitButton.textContent;

    submitButton.disabled = true;
    submitButton.textContent = 'JOINING THE LIST...';

    const profileAttributes = {
      email,
      properties: {
        'FTB Restock Product': productInput?.value || '',
        'FTB Restock Size': variantInput?.value || '',
        'FTB Restock Variant ID': variantIdInput?.value || '',
        'FTB Restock Page URL': window.location.href,
        'FTB Restock Signup Source': 'FTB Restock Modal'
      },
      subscriptions: {
        email: {
          marketing: {
            consent: 'SUBSCRIBED'
          }
        }
      }
    };

    if (phone) {
      profileAttributes.phone_number = phone;
    }

    if (smsConsent && phone) {
      profileAttributes.subscriptions.sms = {
        marketing: {
          consent: 'SUBSCRIBED'
        }
      };
    }

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'FTB Restock Modal',
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: KLAVIYO_LIST_ID
            }
          }
        }
      }
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${KLAVIYO_SITE_ID}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(payload)
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error('FTB restock Klaviyo error:', errorData);
        throw new Error('Klaviyo submission failed.');
      }

      form.hidden = true;

      if (successMessage) {
        successMessage.hidden = false;
      }

      form.reset();
    } catch (error) {
      console.error('FTB restock submission error:', error);

      submitButton.textContent = 'TRY AGAIN';

      setTimeout(() => {
        submitButton.textContent = originalButtonText;
      }, 2500);
    } finally {
      submitButton.disabled = false;
    }
  });
});